export default __webpack_public_path__ + "static/media/dart.9c875a61.png";